import { useRouter } from 'next/router';
import { isWebsitePath } from '../../util/marketingRoutes';
import { GoogleAnalytics } from '@next/third-parties/google';
import { GA_MEASUREMENT_ID } from '../../util/analytics';

/**
 * Empty — the marketing/public shell (/, /demo, /pricing, /iwf-2026, /blog/*…).
 * See src/layouts/index.js for the route allowlist.
 *
 * Carries GA4 for the whole marketing surface. The id is shared with the
 * Centered layout via util/analytics so the two cannot drift apart.
 */
const Empty = ({ children }) => {
  const router = useRouter();
  const website = isWebsitePath(router.asPath || router.pathname) || router.pathname === '/_cms/[...slug]';
  return (
    <>
      <GoogleAnalytics gaId={GA_MEASUREMENT_ID} />
      {website ? <div className='tc-website dark'>{children}</div> : children}
    </>
  );
};

export default Empty;
